<template>
  <div
    v-if="verdicts.length > 0"
    class="space-y-1.5"
  >
    <p class="text-sm font-semibold text-gray-800">{{ t('VerifiedVerdicts') }}:</p>
    <div
      v-for="(verdict, idx) in verdicts"
      :key="verdict.court_judgement_uuid"
    >
      <!-- Error state -->
      <div
        v-if="pdfErrorUuids.includes(verdict.court_judgement_uuid)"
        class="flex items-center gap-2 rounded border border-red-200 bg-red-50 px-2.5 py-1 text-sm text-red-700"
      >
        <span class="flex-1 text-xs">{{ t('VerdictPdfError') }}</span>
        <button
          class="text-xs font-medium underline hover:no-underline"
          @click="emit('open-pdf', verdict.court_judgement_uuid)"
        >
          {{ t('VerdictPdfRetry') }}
        </button>
      </div>

      <!-- Normal row -->
      <div
        v-else
        class="flex items-center gap-2 rounded border border-gray-200 bg-gray-50 py-1 pl-1.5 pr-2 hover:bg-gray-100"
      >
        <button
          class="flex-1 truncate text-left text-sm font-medium text-gray-900 underline decoration-gray-400"
          @click="emit('open-pdf', verdict.court_judgement_uuid)"
        >
          [{{ idx + 1 }}] {{ formatVerdictLabel(t, verdict) }}
        </button>
        <button
          class="shrink-0 text-gray-400 hover:text-gray-700"
          @click="emit('download-pdf', verdict.court_judgement_uuid, verdict.file_number)"
        >
          <Download class="h-4 w-4" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Download } from 'lucide-vue-next'
  import { useTranslation } from '@/composables/useTranslation'
  import { formatVerdictLabel, verdictLabelTranslations } from '@/composables/useVerdictLabels'
  import type { VerdictChunk } from '@/composables/useVerdictChunks'

  defineProps<{
    verdicts: VerdictChunk[]
    pdfErrorUuids: string[]
  }>()

  const emit = defineEmits<{
    'open-pdf': [uuid: string]
    'download-pdf': [uuid: string, fileNumber: string | null]
  }>()

  const { t } = useTranslation({
    en: {
      ...verdictLabelTranslations.en,
      VerifiedVerdicts: 'Verified verdicts',
      VerdictPdfError: 'Could not load verdict PDF',
      VerdictPdfRetry: 'Retry'
    },
    de: {
      ...verdictLabelTranslations.de,
      VerifiedVerdicts: 'Verifizierte Urteile',
      VerdictPdfError: 'Urteil-PDF konnte nicht geladen werden',
      VerdictPdfRetry: 'Erneut versuchen'
    }
  })
</script>
